export const Colors = {
  primary: "#1ABB9C",
  primaryDarker: "#068068",
  secondary: "#2A3F54",
  secondaryLight: "#E9E9E9",
  offwhite: "#F7F7F9",
  dark: "#232325",
  light: "#FFFFFF",
  placeholder: "#747474",
  stroke: "rgba(0, 0, 0, 0.10)",
  greyLight: "#808080",
  greyLightest: "#EEF0F2",
  textColor: "#2D2D2D",
  borderColor: "#D4D4D4",
  buttonError: "#CA2525",
  buttonSuccess: "#60925B",
}
